<div
  *ngIf="mode === 'FULL'"
  class="btn-tab-nested"
  [ngClass]="{'cancelled-registration-row': registration.status === 'CANCELLED' && isCollapsed,
        'category-registrations__participant-row_waiting-list': type === 'WAITING_LIST'}"
>
  <!--TEAM REGS-->
  <div *ngIf="registration.type === 'TEAM'">
    <!-- public info for teams -->
    <div *ngIf="!isEventOrganizerUser" class="row no-margin div-table-row">
      <div class="col-4 no-padding">
        <button (click)="isCollapsed = !isCollapsed" class="btn-tab-nested__toggle">
          <div class="div-table-row__item">{{ registration.participantName }} ({{registration.members.length }})</div>
        </button>
      </div>

      <div class="col-6 no-padding">
        <div class="div-table-row__item">{{ registration.countryOrClub || clubName }}</div>
      </div>

      <!--                                <div class="col-2 d-none d-sm-block no-padding">-->
      <!--                                    <div class="div-table-row__item">-->
      <!--                                        {{ registration.registrationDate | date:'mediumDate' }}-->
      <!--                                    </div>-->
      <!--                                </div>-->
    </div>

    <!-- private info for teams -->
    <div *ngIf="isEventOrganizerUser && isCollapsed" class="row no-margin div-table-row">
      <div class="col-3 no-padding">
        <div class="div-table-row__item div-table-row__item--icon">
          <div class="icon-container" *ngIf="isMusicMissing()">
            <div [ngbTooltip]="'registration.missingMusicTracks' | translate:{count: missingMusicCount()}" tooltipClass="kn-tooltip">
              <svg-icon icon="no-music"></svg-icon>
            </div>
          </div>
          <a href="" (click)="isCollapsed = !isCollapsed">
            {{ registration.participantName }} ({{registration.members.length }})
          </a>
        </div>
      </div>

      <div class="col-3 no-padding">
        <div class="div-table-row__item">{{ registration.countryOrClub || clubName }}</div>
      </div>

      <!--                                <div class="col-2 no-padding">-->
      <!--                                    <div class="div-table-row__item"></div>-->
      <!--                                </div>-->

      <div class="col-2 no-padding">
        <div class="div-table-row__item">
          <ellipsis [tooltipText]="registration.extraAttributes.registrationContacts.club.email">
            <span *copyToCb="registration.extraAttributes.registrationContacts.club.email">
              {{ registration.extraAttributes.registrationContacts.club.email }}
            </span>
          </ellipsis>
        </div>
      </div>

      <div class="col-2 no-padding">
        <div class="div-table-row__item">
          <ellipsis [tooltipText]="registration.extraAttributes.registrationContacts.billing.email">
            <span *copyToCb="registration.extraAttributes.registrationContacts.billing.email">
              {{ registration.extraAttributes.registrationContacts.billing.email }}
            </span>
          </ellipsis>
        </div>
      </div>
      <div class="col-2 no-padding">
        <div class="div-table-row__item d-flex justify-content-between">
          <div>
            <span>{{ registration.registrationDate | date:'mediumDate' }}</span>
            <span *ngIf="type==='WAITING_LIST'">({{waitingListPosition(registration)}})</span>
          </div>
          <div *ngIf="userCanPromoteFromWaitingList && type==='WAITING_LIST'">
            <div class="custom-checkbox category-registrations-row__select-row-checkbox">
              <input
                class="visually-hidden"
                type="checkbox"
                [(ngModel)]="selected"
                (ngModelChange)="selectionChanged()"
                id="selectRegistration{{registration.id}}"
              />
              <label for="selectRegistration{{registration.id}}"> </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div [ngbCollapse]="isCollapsed || isEventOrganizerUser" (ngbCollapseChange)="isCollapsed || (isEventOrganizerUser = $event)" class="btn-tab-nested__content">
      <div class="entry-members">
        <span
          class="entry-members__item"
          [ngClass]="'entry-members__item--' + tm.status"
          *ngFor="let tm of registration.members"
          >{{ tm.firstName}} {{tm.lastName }}
        </span>
      </div>
    </div>
  </div>

  <!--INDIVIDUAL REGS-->
  <!-- public info for individuals -->
  <div *ngIf="!isEventOrganizerUser">
    <div *ngIf="registration.type === 'SINGLE'" class="row no-margin">
      <div class="col-6 col-sm-4 no-padding">
        <div class="div-table-row__item">
          {{ registration.participantName }}&nbsp;
          <span
            *ngIf="teamCompetitionEnabled && registration.extraAttributes.teamCompetition"
            [ngbTooltip]="'registration.rgTeamCompetitionTooltip' | translate"
          >
            <svg-icon icon="flag"></svg-icon>
          </span>
          <!--                    <participation-type-label type="registration.extraAttributes.participationType">-->
          <!--                    </participation-type-label>-->
        </div>
      </div>

      <div class="col-6 no-padding">
        <div class="div-table-row__item">{{ registration.countryOrClub || clubName }}</div>
      </div>
    </div>
  </div>

  <!-- private info for individuals -->
  <div *ngIf="isEventOrganizerUser && isCollapsed">
    <div *ngIf="registration.type === 'SINGLE' || registration.type === 'PERFORMANCE'" class="row no-margin">
      <div class="col-3 no-padding">
        <div class="div-table-row__item div-table-row__item--icon">
          <div class="icon-container" *ngIf="isMusicMissing()">
            <div tooltipClass="kn-tooltip" [ngbTooltip]="'registration.missingMusicTracks' | translate:{count: missingMusicCount()}">
              <svg-icon icon="no-music"></svg-icon>
            </div>
          </div>
          <span>
            <a href="" (click)="isCollapsed = false">{{ registration.participantName }}</a>&nbsp;
            <span
              *ngIf="teamCompetitionEnabled && registration.extraAttributes.teamCompetition"
              [ngbTooltip]="'registration.rgTeamCompetitionTooltip' | translate"
            >
              <svg-icon icon="flag"></svg-icon>
            </span>
            <!--                        <participation-type-label type="registration.extraAttributes.participationType">-->
            <!--                        </participation-type-label>-->
          </span>
        </div>
      </div>

      <div class="col-3 no-padding">
        <div class="div-table-row__item d-flex justify-content-between">
          <span>{{ registration.countryOrClub || clubName }}</span>
          <span
            *ngIf="isMagTeamRegistration"
            class="category-registrations-row__mag-team-icon"
            [ngbTooltip]="'registration.agTeamCompetition' | translate"
            tooltipClass="kn-tooltip"
          >
            <svg-icon icon="t-letter-16"></svg-icon>
          </span>
        </div>
      </div>

      <!-- apparatus -->
      <!--                            <div class="col-2 no-padding">-->
      <!--                                <div class="div-table-row__item"></div>-->
      <!--                            </div>-->

      <div class="col-2 no-padding">
        <!-- {{ registration.extraAttributes.registrationContacts.club.email }} -->
        <div class="div-table-row__item">
          <ellipsis>
            <span *copyToCb="registration.extraAttributes?.registrationContacts?.club?.email">
              {{ registration.extraAttributes?.registrationContacts?.club?.email }}
            </span>
          </ellipsis>
        </div>
      </div>

      <div class="col-2 no-padding">
        <!-- {{ registration.extraAttributes.registrationContacts.billing.email }} -->
        <div class="div-table-row__item">
          <ellipsis>
            <span *copyToCb="registration.extraAttributes?.registrationContacts?.billing?.email">
              {{ registration.extraAttributes.registrationContacts?.billing?.email }}
            </span>
          </ellipsis>
        </div>
      </div>
      <div class="col-2 no-padding">
        <div class="div-table-row__item d-flex justify-content-between">
          <div>
            <span>{{ registration.registrationDate | date:'mediumDate' }}</span>
            <span *ngIf="type==='WAITING_LIST'">({{waitingListPosition(registration)}})</span>
          </div>
          <div *ngIf="userCanPromoteFromWaitingList && type==='WAITING_LIST'">
            <div class="custom-checkbox category-registrations-row__select-row-checkbox">
              <input
                class="visually-hidden"
                type="checkbox"
                [(ngModel)]="selected"
                (ngModelChange)="selectionChanged()"
                [id]="'selectRegistration_' + registration.id"
              />
              <label [for]="'selectRegistration_' + registration.id"> </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isEventOrganizerUser && !isCollapsed" class="registration-detail-container">
    <registration-detail
      [currentUserOrgId]="getCurrentUserOrgId()"
      [event]="event"
      [registration]="registration"
      (onDone)="collapseRow()"
    >
    </registration-detail>
    <button type="button" class="btn btn-top-right btn-overlay close-button" (click)="collapseRow()">
      <svg-icon icon="cross-45"></svg-icon>
    </button>
  </div>
</div>

<div *ngIf="mode === 'MOBILE'" class="btn-tab-nested" [ngClass]="getRowClasses()">
  <button
    *ngIf="isCollapsed || !isEventOrganizerUser"
    (click)="isCollapsed = !isCollapsed"
    class="btn-tab-nested__toggle btn-tab-nested__toggle__mobile div-table-row"
  >
    <div class="row no-margin">
      <div class="col-6 no-padding">
        <div class="div-table-row__item div-table-row__item--mobile">
          <span>{{ registration.participantName }}&nbsp;</span>
          <span
            *ngIf="teamCompetitionEnabled && registration.extraAttributes.teamCompetition"
            [ngbTooltip]="'registration.rgTeamCompetitionTooltip' | translate"
          >
            <svg-icon icon="flag"></svg-icon>
          </span>
          <participation-type-label [type]="registration.extraAttributes?.participationType">
          </participation-type-label>
        </div>
      </div>

      <div class="col-6 no-padding">
        <div class="div-table-row__item div-table-row__item--mobile">{{ registration.countryOrClub || clubName }}</div>
      </div>
    </div>
  </button>

  <div [(ngbCollapse)]="isCollapsed">
    <!-- private info -->
    <div *ngIf="isEventOrganizerUser && !isCollapsed" class="registration-detail-container">
      <registration-detail
        [currentUserOrgId]="getCurrentUserOrgId()"
        [event]="event"
        [registration]="registration"
        (onDone)="collapseRow()"
      >
      </registration-detail>
      <button type="button" class="btn btn-top-right btn-overlay close-button" (click)="collapseRow()">
        <svg-icon [icon]="'cross-45'"></svg-icon>
      </button>
    </div>

    <!-- public info for teams-->
    <div *ngIf="!isEventOrganizerUser && !isCollapsed && registration.type === 'TEAM'" class="entry-members">
      <span
        class="entry-members__item"
        [ngClass]="'entry-members__item--' + tm.status"
        *ngFor="let tm of registration.members"
        >{{ tm.firstName}} {{tm.lastName }}
      </span>
    </div>
  </div>
</div>
